import { FetchSsoActionTypes } from '../actions/SsoActions';
const initialState = {
  required: false,
  exemptUsers: []
};
export default ((state = initialState, action) => {
  var _ref, _action$payload$, _action$payload$0$exe, _action$payload$2;
  switch (action.type) {
    case FetchSsoActionTypes.SUCCESS:
      return Object.assign({}, state, {
        required: (_ref = ((_action$payload$ = action.payload[0]) === null || _action$payload$ === void 0 ? void 0 : _action$payload$.requirement) === 'REQUIRED') !== null && _ref !== void 0 ? _ref : false,
        exemptUsers: (_action$payload$0$exe = (_action$payload$2 = action.payload[0]) === null || _action$payload$2 === void 0 ? void 0 : _action$payload$2.exemptUsers) !== null && _action$payload$0$exe !== void 0 ? _action$payload$0$exe : []
      });
    default:
      return state;
  }
});